export function Check() {
  return (
    <path
      fill="currentColor"
      d="M47.168 8.812c-1.11-1.083-2.909-1.083-4.018 0L18.059 33.304 4.85 20.412c-1.11-1.083-2.909-1.083-4.019 0-1.11 1.083-1.11 2.839 0 3.922L16.05 39.188c.555.541 1.282.812 2.01.812.727 0 1.454-.27 2.009-.812l27.1-26.454c1.11-1.083 1.11-2.839 0-3.922"
    />
  )
}
